export default {
  methods: {
    languagesCustomLabel({ name, native_name }) {
      return `${name} ( ${native_name} )`;
    },
  },
};
